import React from 'react';

const Button = ({ 
  children, 
  className = '', 
  variant = 'default', 
  size = 'default', 
  disabled = false, 
  ...props 
}) => {
  const baseClasses = 'aa-btn';

  const variants = {
    default: 'aa-btn-primary',
    outline: 'aa-btn-outline',
    ghost: 'aa-btn-ghost'
  };

  const sizes = {
    default: '',
    sm: 'aa-btn-sm',
    lg: ''
  };

  const classes = `${baseClasses} ${variants[variant] || ''} ${sizes[size] || ''} ${className}`;
  
  return (
    <button className={classes} disabled={disabled} {...props}>
      {children}
    </button>
  );
};

export { Button };